import { api } from '@/lib/api'
import type {
  ConfirmPlaidPayload,
  CreateLinkTokenResponse,
  PlaidConnection,
  PlaidExchangeResponse,
} from './types'

export const plaidApi = {
  list: () => api.get<PlaidConnection[]>('/api/plaid/connections'),
  createLinkToken: () => api.post<CreateLinkTokenResponse>('/api/plaid/create_link_token'),
  exchangePublicToken: (body: {
    public_token: string
    metadata: unknown
    fromDate: string
    toDate: string
    statementType: string
    period: string | null
  }) => api.post<PlaidExchangeResponse>('/api/plaid/exchange_public_token', body),
  syncAll: () => api.post<PlaidExchangeResponse>('/api/plaid/sync_transactions'),
  syncOne: (id: number) =>
    api.post<PlaidExchangeResponse>(`/api/plaid/sync_transactions/${id}`),
  deleteConnection: (id: number) => api.del<{ message?: string }>(`/api/plaid/connections/${id}`),
  schedule: (id: number, body: { value: number; unit: string; nextSyncISO: string }) =>
    api.post<{ message?: string }>(`/api/plaid/connections/${id}/schedule`, body),
  confirm: (payload: ConfirmPlaidPayload) =>
    api.post<{ message?: string }>('/api/plaid/confirm-plaid', payload),
}
